import { InjectableClass } from '@fino/lib-injection';
import template from './loadingOverlay.html';

class LoadingOverlayController extends InjectableClass {
  constructor(appConfig, configService) {
    'ngInject';
    super({ appConfig, configService });
  }
}

export default {
  restrict: 'E',
  template,
  controllerAs: 'vm',
  bindings: {
    loading: '=',
  },
  controller: LoadingOverlayController,
};



// WEBPACK FOOTER //
// ./src/app/common/ui/loadingOverlay/loadingOverlay.component.js